/**
 * AreaAnalysisCard
 * 
 * @Author: Focci
 * @Date: 2023-08-11 17:20:44
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-11 17:20:44
 */

'use client'

// import PropTypes from 'prop-types'
import ReactECharts from '@comp/echarts'
import { formatPrice } from '@lib/utils'
import { map } from 'lodash-es'

function getOption(data) {
  const xAsix = map(data, 'year').reverse()
  const tradeData = map(data, 'median').reverse()
  const option = {
    tooltip: {
      trigger: 'item',
      axisPointer: { type: 'line' },
      formatter: ({ value }) => (
        `<div style="text-align:center;"><b>$${formatPrice(value)}</b></div>`
      ),
    },
    grid: {
      left: 'auto',
      right: '1%',
      bottom: '3%',
      top: '8%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        data: xAsix
      }
    ],
    yAxis: [
      {
        type: 'value',
        scale: true,
        axisLabel: {
          formatter: (value) => `$${formatPrice(value)}`
        },
        axisLine: {
          lineStyle: { color: '#3B4450' }
        },
        axisTick: {
          show: false
        },
        splitLine: {
          lineStyle: { color: ['#f2f2f2'] }
        }
      }
    ],
    series: [
      {
        name: '历史估价',
        type: 'line',
        connectNulls: true,
        data: tradeData,
        symbolSize: 10,
        itemStyle: {
          color: '#20A4F8',
          backgroundColor: '#20A4F8',
        },
        lineStyle: {
          color: '#20A4F8',
        }
      }
    ]
  }

  return option
}

export default function AreaAnalysisCard({
  data = []
}) {
  const option = getOption(data)
  return (
    <ReactECharts
      option={option}
      style={{ height: '12rem' }}
    />
  )
}

// AreaAnalysisCard.propTypes = {
//   className: PropTypes.string,
// }
